import React from 'react'
import { useLocation } from 'react-router'
import {
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
} from '@news-mono/web-common'

import type { SevenNewsSection } from '../__styling/settings/sections/sevennews'
import { CollectionRouteProps } from '../collections'
import { calculateExpectedCardCountFromContentData } from '../collections/collections-props.routing'
import { LoadMoreRouteProps } from '../data-controllers/LoadMore/LoadMore'
import { ResponsiveContainer } from '../content/Picture/responsive'

import { sectionThemeOverrider, ThemeMargins } from '../__styling'
import { SchemeOverrider } from '../themes/ThemeOverrider/SchemeOverrider'

import { mapTopVideoMeta } from '../VideoHub/helpers/mapToVideoMeta'
import { VerticalVideoHub } from './VerticalVideoHub'
import { StyledVerticalVideoHub } from './VerticalVideoHub.styled'
import { VerticalVideoCarousel } from './VerticalVideoCarousel'

export interface VerticalVideoHubRouteProps
    extends CollectionRouteProps,
        LoadMoreRouteProps,
        ResponsiveContainer {
    adUnitPath: string
    showAds?: boolean
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
    verticalSpacing?: keyof ThemeMargins
    sectionOverride?: SevenNewsSection
    lazyLoad?: boolean
}

export const VerticalVideoHubRegistration = createRegisterableComponentWithData(
    'vertical-video-hub',
    ContentDataDefinitionLoader,
    (props: VerticalVideoHubRouteProps, data, services) => {
        const location = useLocation()
        if (!data.loaded) {
            const skeletonCount = data.dataDefinitionArgs
                ? calculateExpectedCardCountFromContentData(
                      data.dataDefinitionArgs,
                  )
                : 5

            return (
                <SchemeOverrider
                    override={sectionThemeOverrider(
                        'sevennews',
                        props.sectionOverride || 'default',
                    )}
                >
                    <StyledVerticalVideoHub
                        verticalGutters={props.verticalGutters}
                        verticalSpacing={props.verticalSpacing}
                    >
                        <VerticalVideoCarousel
                            videos={[]}
                            cardItems={[]}
                            onSelect={() => {}}
                            isLoading={true}
                            skeletonCount={skeletonCount}
                        />
                    </StyledVerticalVideoHub>
                </SchemeOverrider>
            )
        }

        const videoList = mapTopVideoMeta(data.result.publications)

        return (
            <SchemeOverrider
                override={sectionThemeOverrider(
                    'sevennews',
                    props.sectionOverride || 'default',
                )}
            >
                <VerticalVideoHub
                    videos={videoList}
                    onEvent={services.onEvent}
                    adUnitPath={props.adUnitPath}
                    showAds={props.showAds}
                    currentPath={location.pathname}
                    publicUrl={services.config.publicUrl}
                    verticalGutters={props.verticalGutters}
                    verticalSpacing={props.verticalSpacing}
                    lazyLoad={props.lazyLoad}
                    loadMoreDataDefinition={data.dataDefinitionArgs}
                    loadMoreInitialData={data}
                    loadMoreServices={services}
                />
            </SchemeOverrider>
        )
    },
)
